import React, { useEffect, useState } from "react";
import ModalReserveMobile from "./ModalReserveMobile";
import ModalSelectDate from "components/ModalSelectDate";
import converSelectedDateToString from "utils/converSelectedDateToString";
import ButtonPrimary from "shared/Button/ButtonPrimary";
import { useAppContext } from "AppContext";

const MobileFooterSticky = () => {
  const [startDate, setStartDate] = useState<Date | null>(null);
  const [endDate, setEndDate] = useState<Date | null>(null);

  const { filterState, handleReserveClick, totalAmout, base_price } = useAppContext();

  useEffect(() => {
    const date = filterState?.checkInDate ? new Date(filterState?.checkInDate) : null
    setStartDate(date)
  }, [filterState?.checkInDate])


  useEffect(() => {
    const date = filterState?.checkOutDate ? new Date(filterState?.checkOutDate) : null
    setStartDate(date)
  }, [filterState?.checkOutDate])


  return (
    <div className="block lg:hidden fixed bottom-0 inset-x-0 py-2 sm:py-3 bg-white dark:bg-neutral-800 border-t border-neutral-200 dark:border-neutral-6000 z-40">
      <div className="container flex items-center justify-between">
        <div className="">
          <span className="block text-xl font-semibold">
            € {!isNaN(Number(base_price)) ? Number(base_price).toFixed(2) : "0.00"}
            <span className="ml-1 text-sm font-normal text-neutral-500 dark:text-neutral-400">
              /night
            </span>
          </span>
          {/* <ModalSelectDate
            renderChildren={({ openModal }) => (
              <span
                onClick={openModal}
                className="block text-sm underline font-medium"
              >
                {converSelectedDateToString([startDate, endDate])}
              </span>
            )}
          /> */}
        </div>
        <ModalReserveMobile
          renderChildren={({ openModal }) => (
            <ButtonPrimary
              sizeClass="px-5 sm:px-7 py-3 !rounded-2xl"
              onClick={handleReserveClick}
            >
              Reserve
            </ButtonPrimary>
          )}
        />
      </div>
    </div>
  );
};

export default MobileFooterSticky;
